import Vue from 'vue'
import ShareTip from './ShareTip.vue'

let ShareConstructor, ShareDom
try {
  // 返回一个 扩展实例构造器
    ShareConstructor = Vue.extend(ShareTip)
  // 实例化
    ShareDom = new ShareConstructor({
    el: document.createElement('div'),
  })

  // 把 实例化的 share.vue 添加到 body 里
  document.body.appendChild(ShareDom.$el)
} catch(e) {
  console.error(e)
}


// 注册为全局组件的函数
function registryShareTip() {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.$shareTip.show()
  Vue.prototype.$shareTip = {
    show() {
        ShareDom.isShow = true
    }
  }
}

export default registryShareTip
